import axios from 'axios';
import { API_URL } from 'app_constants';
import qs from 'qs'

export default () => axios.create({
  baseURL: API_URL,
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  paramsSerializer: function (params) {
    return qs.stringify(params, { encode: false, arrayFormat: 'comma' })
  },
});
